export default {
	id: 'SIMPLE_PAYWALL_3M_69_3M_19_99',
	providers: {
		paltaMap: {
			USD: 'simple_premium_3m_69_3m_19_99_usd',
			EUR: 'simple_premium_3m_69_3m_19_99_eur',
		},
		primer: 'prd_wx4AeKrjyj3Q',
	},
	model: {
		commitment_period: 0,
		intro_period_value: 3,
		intro_period_type: 'month',
		next_period_value: 3,
		next_period_type: 'month',
	},
	trial: {
		days: 90,
		priceMap: {
			USD: 19.99,
			EUR: 19.99,
		},
		originalPriceMap: {
			USD: 69,
			EUR: 69,
		},
	},
	subscription: {
		interval: 'month',
		intervalCount: 3,
		priceMap: {
			USD: 69,
			EUR: 69,
		},
	},
}
